interface StateBlockProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function StateBlock({
  icon = 'ri-film-line',
  title,
  description,
  actionText,
  onAction,
}: StateBlockProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center bg-background-100 rounded-lg border border-background-200/70">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}